export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9523.7b8a50c9.jpg";